import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../../../../context/AuthContext';
import BolsaOnboarding from './BolsaOnboarding';
import SystemLoadingOverlay from './SystemLoadingOverlay';

const BolsaSystemWrapper = ({ system, activationData, onLoaded }) => {
  const { user } = useAuth();
  const [status, setStatus] = useState('loading'); // loading, onboarding, ready
  const [initialRole, setInitialRole] = useState(null);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const userId = user?.user_id || user?.id;
  useEffect(() => {
    const checkStatus = async () => {
      if (!userId) {
        setStatus('ready');
        return;
      }
      try {
        // Consultar el estado en la API del HOLDING (fuente de verdad central)
        const response = await axios.post('https://apiweb.hitpoly.com/ajax/bolsaController.php', {
          accion: 'getProfileStatus',
          user_id: userId
        });
        
        if (response.data.success && response.data.data?.onboarding_finished) {
          setStatus('ready');
        } else {
          setStatus('onboarding');
        }
      } catch (error) {
        setStatus('ready'); // Fallback to ready to not block users if API fails
      }
    };

    checkStatus();

    // Escuchar mensaje para forzar onboarding desde la Bolsa
    const handleMessage = (event) => {
      if (event.data?.type === 'START_BOLSA_ONBOARDING') {
        // Si el mensaje indica un rol específico (o lo asumimos por el contexto)
        setInitialRole('professional'); 
        setStatus('onboarding');
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [userId]);

  if (status === 'onboarding') {
    return <BolsaOnboarding 
      onFinished={() => {
        setStatus('ready');
        setInitialRole(null);
      }} 
      initialRole={initialRole}
    />;
  }

  const showLoader = status === 'loading' || !isIframeLoaded;

  return (
    <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
      {showLoader && (
        <SystemLoadingOverlay
          title={`Cargando ${system.title}`}
          subtitle={status === 'loading' ? "Verificando tu perfil..." : "Sincronizando tu contenido..."}
          color={system.color || '#3B207F'}
        />
      )}
      <iframe
        key={`${system.id}-${activationData?.timestamp || 0}`}
        src={activationData?.initialUrl}
        title={system.title}
        allow="clipboard-write"
        onLoad={() => {
          setIsIframeLoaded(true);
          onLoaded();
        }}
        style={{
          border: "none", 
          width: "100%", 
          height: "100%",
          display: "block"
        }}
      />
    </Box>
  );
};

export default BolsaSystemWrapper;
